<template>
  <div class="base-item"
    :class="{'is-opening': opening, 'is-m': isM}"
  >
    <div class="base-item-hd" :class="{'is-multi': multi}">
      <div class="base-item-name">
        <slot name="name">
          <span>{{ item.name }}</span>
        </slot>
        <img v-if="item.pictures" class="icon-ques" src="./imgs/q.svg">
      </div>
      <div class="selected-name text-muted" v-if="!multi && curretValue && showSelectedInfo">
        <slot>
          <span class="selected-label">{{ $t('evaluate.selected') }} : </span>
          <span class="selected-item-name">{{ curretValue.name }}</span>
        </slot>
      </div>
      <div
        class="ev-edit fr pointer"
        v-show="opening || hasValue"
        @click="actionClick(item)">
        <slot name="edit" :opening="opening">
          <span v-show="autoFlod && !opening && hasValue">{{ $t('evaluate.edit') }}</span>
        </slot>
      </div>
      <div class="ev-edit fr" v-show="!opening && !hasValue">
        {{ $t('evaluate.unselected') }}
      </div>
    </div>
    <div class="base-item-bd" v-show="opening || (!autoFlod && !(!curretValue || curretValue.length === 0))">
      <ul class="answer-list clearfix">
        <li
          class="answer-item fl"
          v-for="(aitem, aindex) in item.questions"
          :ref="'item' + aindex"
          :key="aindex"
          :class="{ 'is-active': computeIsSelected(aitem.id), 'has-pic': !!aitem.pictures }"
          @click="handleBTap(item, aitem, $event)"
        >
          <div class="answer-txt">
            <slot name="answer" :selected="computeIsSelected(aitem.id)" :item="aitem">
              {{ aitem.name }}
            </slot>
          </div>
          <popover
            :trigger="trigger"
            :append-to-body="false"
            :value="isPopoverVisible(aitem.id)"
            @show="popoverShow"
            @hide="popoverHide"
          >
            <div class="answer-icon-wrap" slot="reference" @click.stop="popTigger(aitem.id)">
              <img v-if="prevImg && aitem.pictures" class="icon-ques" :src="aitem.pictures[0]">
              <img v-if="!prevImg" class="icon-ques" src="./imgs/q.svg">
            </div>
            <img src="./imgs/icon_close_2.png" alt="" class="close-x" v-show="isPopoverVisible(aitem.id)" @click="popoverHide()">
            <ev-swiper :data="computedPic(aitem)"></ev-swiper>
          </popover>
        </li>
      </ul>
    </div>
    <hr class="hr" v-show="!opening">
  </div>
</template>

<script>
import { isArray } from 'lodash';
import { Popover, Message } from 'element-ui';
import evSwiper from './evaluate-tip/evaluate-tip';
import isMobile from 'ismobilejs';

const touchMoveHandler = (ev) => {
  ev.preventDefault();
  ev.stopPropagation();
  return false;
};

const getModal = () => {
  if (getModal.instance) {
    return getModal.instance;
  }
  const div = document.createElement('div');
  div.className = 'v-modal';
  div.style.zIndex = '1000';

  document.body.appendChild(div);
  div.addEventListener('touchmove', touchMoveHandler);
  getModal.instance = {
    show () {
      div.style.display = 'block';
    },
    hide () {
      div.style.display = 'none';
    },
    destory () {
      this.hide();
      // div.removeEventListener('touchmove', touchMoveHandler);
      // parentDom.removeChild(div);
    }
  };
  return getModal.instance;
};

export default {
  props: {
    item: Object,
    value: [Array, String, Object],
    opening: Boolean,
    selected: Boolean,
    prevImg: Boolean,
    autoFlod: Boolean,
    multi: Boolean,
    showSelectedInfo: Boolean
  },
  data () {
    return {
      trigger: 'click',
      isM: false,
      currentPop: ''
    };
  },
  components: {
    evSwiper,
    Popover
  },
  computed: {
    curretValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    hasValue () {
      return !(!this.value || this.value.length === 0);
    }
  },
  beforeMount () {
    if (typeof window !== 'undefined') {
      this.isM = isMobile.phone;
      this.trigger = this.isM ? 'click' : 'hover';
    }
  },
  destroyed () {
    if (!this.isM) {
      return;
    }
    const modal = getModal();
    modal.destory();
  },
  methods: {
    isPopoverVisible (id) {
      return this.currentPop === id;
    },
    computeIsSelected (id) {
      if (!this.curretValue) {
        return false;
      }

      if (this.curretValue.id === id) {
        return true;
      }

      if (isArray(this.curretValue)) {
        return this.curretValue.find(item => item.id === id);
      }
    },
    actionClick (pitem) {
      this.$emit('actionClick', pitem);
    },
    handleBTap (parentItem, subItem, ev) {
      if (this.$store.state.productParam.disabeldItems[subItem.id]) {
        return Message.warning(this.$store.state.productParam.disabeldItems[subItem.id]);
      }

      if (subItem.disabledItem && subItem.disabledItem.disabled === '1') {
        return Message.warning(subItem.disabledItem.desc || '为了您的隐私安全，暂不回收此类机器');
      }

      if (!this.multi) {
        this.curretValue = subItem;
      } else {
        const index = this.curretValue.findIndex(item => item.id === subItem.id);
        if (index > -1) {
          this.curretValue.splice(index, 1);
        } else {
          this.curretValue.push(subItem);
        }
      }
      this.$emit('select', parentItem, subItem, ev);
    },
    popoverShow () {
      if (!this.isM) {
        return;
      }
      const modal = getModal();
      modal.show();
      // this.currentPop = '';
    },
    popoverHide () {
      if (!this.isM) {
        return;
      }
      const modal = getModal();
      modal.hide();
      this.currentPop = '';
    },
    popTigger (id) {
      this.currentPop = id;
    },
    computedPic (aitem) {
      return {
        desc: aitem.picdesc,
        picture: aitem.pictures
      };
    }
  }
};
</script>

<style type="text/css" src="./evaluate.css" scoped></style>



// WEBPACK FOOTER //
// src/core/evaluate/item.vue